import React from 'react';
import { NumericFormat, NumericFormatProps } from 'react-number-format';

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  prefix?: string;
  fixedDecimalScale?: boolean;
  suffix?: string;
  allowNegative?: boolean;
}
export const NumericInputField = React.forwardRef<NumericFormatProps, CustomProps>(
  function NumericInputField(props, ref) {
    const {
      onChange,
      prefix = '',
      suffix = '',
      fixedDecimalScale = false,
      allowNegative = false,
      ...other
    } = props;

    return (
      <NumericFormat
        {...other}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
        thousandSeparator
        valueIsNumericString
        prefix={prefix}
        decimalScale={2}
        fixedDecimalScale={fixedDecimalScale}
        suffix={suffix}
        isAllowed={(values) => {
          const { floatValue } = values;
          return allowNegative ? true : floatValue === undefined || floatValue >= 0;
        }}
      />
    );
  },
);
